import styled from 'styled-components'
import theme from '../../Theme'
import { Link } from "gatsby"

const NavLink = styled(Link)`
font-weight: ${theme.titleFont.fontWeight};
font-family: ${theme.titleFont.fontFamily};
text-transform: ${theme.titleFont.textTransform};
transition: color 0.4s;
color: ${theme.dark};
text-transform: uppercase;
font-size: 20px;
text-decoration: none;

&:focus {
  outline: none;
}

&:hover {
  transition: color 0.15s;
  text-decoration: none;
  color: ${theme.highlight};
}
`

export const MenuNavLink = styled(NavLink)`
  margin-bottom: 16px
`

export const HeaderNavLink = NavLink

export const HeaderNavLinkSpacer = styled(styled.span(theme.titleFont))`
color: ${theme.dark};
text-transform: uppercase;
font-size: 20px;
margin-left: 10px;
margin-right: 10px;
`